var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalDetailsMatchCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.0332,
    y: 4.24023,
    width: 18.3333,
    height: 13.3589,
    rx: 3,
    fill: "#3158F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44887 7.50621C10.1811 8.23844 10.1811 9.42562 9.44887 10.1579C8.71664 10.8901 7.52946 10.8901 6.79722 10.1579C6.06499 9.42562 6.06499 8.23844 6.79722 7.50621C7.52946 6.77397 8.71664 6.77397 9.44887 7.50621Z",
    fill: "#F1F3F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5391 8.6237H16.8724",
    stroke: "#F1F3F4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 11.9577H13.5391",
    stroke: "#F1F3F4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1186 14.4577C10.9728 14.0918 10.7478 13.7635 10.4586 13.496V13.496C9.96945 13.0427 9.32779 12.791 8.66112 12.791H7.58445C6.91779 12.791 6.27612 13.0427 5.78695 13.496V13.496C5.49779 13.7635 5.27279 14.0918 5.12695 14.4577",
    stroke: "#F1F3F4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetailsMatchCheck);
export default __webpack_public_path__ + "static/media/personal_details_match_check.1768a6e3eaa55cdd2d524284efdc985d.svg";
export { ForwardRef as ReactComponent };